export default __webpack_public_path__ + "static/media/AddPartyMember.2b8d6b49.mp4";